<template>
  <div>
    <add-new-school-grade :is-add-new-school-grade-sidebar-active.sync="isAddNewSchoolgradeSidebarActive"
      :selectSchoolId="selectSchoolId" @sendgradedata="sendgradedata" />

    <add-edit-school-grade :is-add-edit-school-grade-sidebar-active.sync="isAddEditSchoolGradeSidebarActive"
      :Editschoolgradeid="Editschoolgradeid" :Editschoolgradename="Editschoolgradename"
      :Editschoolgradeimg="Editschoolgradeimg" @clickeditschoolgradedata="clickeditschoolgradedata" />

    <b-card no-body>
      <div class="m-2">
      <b-row>
        <b-col cols="12" class="text-right">
          <b-form-input
            v-model="searchQuery"
            class="d-inline-block mr-1"
            placeholder="Search..."
            style="width: 250px;"
          />
          <!-- <b-button
            variant="primary"
            @click="isAddNewSchoolgradeSidebarActive = true"
          > -->
          <b-button
            variant="primary"
            @click="openAssignGrade()"
          >
            <span class="text-nowrap">Assign Grade</span>
          </b-button> 
        </b-col>
      </b-row>
      </div>

      <b-card no-body class="mb-0">
        <b-table-simple hover caption-top responsive class="rounded-bottom mb-0">
          <b-thead head-variant="light">
            <b-tr>
              <b-th>No.</b-th>
              <b-th>Grade Image</b-th>
              <b-th>Grade Name</b-th>
              <b-th v-if="removeButtons == true">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <tr v-for="(grade, index) in getSchools()" :key="grade._id">
              <td>{{ index + 1 }}</td>
              <b-td>
                  <div v-if="grade && grade.classImg">
                      <template v-if="getFileExtensionFromUrl(grade.classImg) === 'json'">
                          <LottieView :url="grade.classImg" :forTopic="true" :key="keyForLottie" />
                      </template>

                      <template v-else-if="getFileExtensionFromUrl(grade.classImg) === 'lottie'">
                          <DoLottieView :url="grade.classImg" :forTopic="true"
                          :id="`subjects_${index}_${uuidv4()}`" :key="keyForLottie" />
                      </template>

                      <template v-else>
                          <img
                          :src="grade.classImg || 'invalid_url.jpg'"
                          alt="School Image"
                          @error="imgError"
                          style="width: 100px; height: 100px"
                          />
                      </template>
                  </div>
                </b-td>
              <td>{{ grade.className }}</td>

              <b-td v-if="removeButtons == true">
                  <b-dropdown variant="link" no-caret>
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                    </template>

                    <b-dropdown-item @click="activeEditSchoolGradeSidebar(grade)
                      ">
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">Edit</span>
                    </b-dropdown-item>

                    <b-dropdown-item @click="activeDeleteSchoolgradeSidebar(grade._id)
                      ">
                      <feather-icon icon="TrashIcon" />
                      <span class="align-middle ml-50">Delete</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-td>
            </tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
    </b-card>


    <b-modal
id="assign-grade-modal"
title="Assign Grades"
v-model="isAssignGradeModalVisible"
hide-footer
size="lg"
>
<div v-if="selectedGrades.length">
  <ul class="list-group">
    <li
      class="list-group-item d-flex justify-content-between align-items-center"
      v-for="(grade, index) in selectedGrades"
      :key="grade._id"
    >
      {{ index + 1 }}. {{ grade.className }}
      <span>
        <b-button size="sm" variant="outline-danger" @click="removeFromSelected(grade._id)">
          Remove
        </b-button>
      </span>
    </li>
  </ul>
</div>
<div v-else class="text-center text-muted">No grades selected.</div>

<div class="mt-3 text-right">
  <b-button variant="secondary" @click="isAssignGradeModalVisible = false">Cancel</b-button>
  <b-button variant="primary" @click="saveAssignedGrades()">Save</b-button>
</div>
</b-modal>

  <b-modal
    id="grade-list-modal"
    v-model="isGradeModalVisible"
    title="Grade List"
    size="xl"
    hide-footer
  >
    <b-card no-body class="mb-0">
      <b-table-simple hover caption-top responsive class="rounded-bottom mb-0">
        <b-thead head-variant="light">
          <b-tr>
            <b-th></b-th>
            <b-th>No.</b-th>
            <b-th>Grade Image</b-th>
            <b-th>Grade Name</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
            <tr v-for="(grade, index) in table_data_grade" :key="grade._id">
            <b-th>
              <b-form-checkbox
                v-model="grade.isSelected"
                :value="true"
                :unchecked-value="false"
                class="mr-1"
              />
            </b-th>
            <td>{{ index + 1 }}</td>
            <b-td>
              <div v-if="grade && grade.classImg">
                <template v-if="getFileExtensionFromUrl(grade.classImg) === 'json'">
                  <LottieView :url="grade.classImg" :forTopic="true" :key="keyForLottie" />
                </template>
                <template v-else-if="getFileExtensionFromUrl(grade.classImg) === 'lottie'">
                  <DoLottieView :url="grade.classImg" :forTopic="true" :id="`subjects_${index}`" :key="keyForLottie" />
                </template>
                <template v-else>
                  <img
                    :src="grade.classImg || 'invalid_url.jpg'"
                    alt="School Image"
                    @error="imgError"
                    style="width: 100px; height: 100px"
                  />
                </template>
              </div>
            </b-td>
            <td>{{ grade.className }}</td>
          </tr>
        </b-tbody>
      </b-table-simple>
      <div class="text-right p-2">
    <b-button variant="primary" @click="selectBoxGrade">Save</b-button>
  </div>
    </b-card>
  </b-modal>
  </div>
</template>


<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTd,
  BTbody,
  BTfoot,
  BFormCheckbox,
  BTab,
  BTabs,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { BBreadcrumb } from "bootstrap-vue";
import AddNewSchoolGrade from "@/views/app/list/users-list/AddNewSchoolGrade.vue";
import AddEditSchoolGrade from "@/views/app/list/users-list/AddEditSchoolGrade.vue";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
//   import LottieView from "./components/question/LottieView.vue";
import DoLottieView from "@/views/components/question/DoLottieView.vue";
import LottieView from "@/views/components/question/LottieView.vue";
//   import DoLottieView from "./components/question/DoLottieView.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
  components: {
    BBreadcrumb,
    name: 'AssignGrade',
    AddNewSchoolGrade,
    AddEditSchoolGrade,
    BCard,
    BRow,
    ToastificationContent,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTfoot,
    vSelect,
    BFormCheckbox,
    LottieView,
    DoLottieView,
    uuidv4,
    BTab,
    BTabs,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      isGradeModalVisible: false,
      table_data_grade: [],
      isAssignGradeModalVisible: false,
      selectedGrades: [],
      selectSchoolId:"",
      Editschoolgradeid: "",
      Editschoolgradename: "",
      isAddNewSchoolgradeSidebarActive: false,
      isAddEditSchoolGradeSidebarActive: false,
      searchQuery: "",
      table_data: {},
      Editschoolgradeimg: "",
      EditsubjectOrder: 0,
      Editsubjectplaytype:"",
      levelidedit: "",
      Editlevel: "",
      EditLevelname: "",
      EditNoofquestion: "",
      AddSubcategoryid: "",
      deletelevel: { delete_id: "" },
      perPage: 5,
      perPageOptions: [10, 25, 50, 100],
      alertData: "",
      deleteclassdata: {
        id: "",
      },
      deletesubjectdata: {
        class_id: "",
        subject_id: "",
      },
      toastMessage: '',
      removeButtons: "",
      keyForLottie: 0,
    };
  },
  mounted() {
    this.removeButtons = JSON.parse(localStorage.getItem("permission")).permission.some(permission => permission === "manage_subjects");
  },
  created() {
    this.selectSchoolId = this.$route.params.schoolId;
    this.gettabledata();
    this.fetchGrades();

  },
  methods: {

    uuidv4,
    getFileExtensionFromUrl(url) {
      if (!url) return '';
      const path = url.split('?')[0].split('#')[0];
      const extension = path.split('.').pop();

      if (extension === path) return '';

      return extension;
    },

    imgError(event) {
      if (!event.target.dataset.errorHandled) {
        event.target.dataset.errorHandled = true;
        event.target.src = 'https://i.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.webp';
      }
    },
    openAssignGrade() {
      this.isGradeModalVisible = true;
      this.$bvModal.show("grade-list-modal");
    },
    selectBoxGrade() {
      this.selectedGrades = this.table_data_grade.filter(g => g.isSelected);
      this.isAssignGradeModalVisible = true;
    },

    removeFromSelected(id) {
      this.selectedGrades = this.selectedGrades.filter(g => g._id !== id);

      const gradeInList = this.getSchools().find(g => g._id === id);
      if (gradeInList) gradeInList.isSelected = false;
    },

    saveAssignedGrades() {
      if (this.selectedGrades.length === 0) {
        this.$bvToast.toast('No grades selected!', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        return;
      }
      const schoolId = JSON.parse(localStorage.getItem("schoolid"));

      const payload = this.selectedGrades.map(grade => ({
        school_id: schoolId,
        grade_id: grade._id
      }));

      axios
        .post(process.env.VUE_APP_API_URL +'/school_grade/create', {Grade : payload },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          }
        }
        )
        .then((response) => {
          this.toastMessage = "Grade Successfully Added";
          this.toastNotification("success");

          this.isAssignGradeModalVisible = false;
          this.isGradeModalVisible = false;

          this.selectedGrades = [];
          this.table_data_grade.forEach(g => (g.isSelected = false));
          this.isAssignGradeModalVisible = false;
          this.gettabledata();
        })
        .catch((error) => {
          this.toastMessage = "Try Again Grade Not Edit";
          this.toastNotification("danger");
        });
    },


    fetchGrades: function () {
      axios

       const schoolId = JSON.parse(localStorage.getItem("schoolid"));

        axios.get(`${process.env.VUE_APP_API_URL}/grade/all`, {
          // params: { schoolId },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((get_response) => {


          this.table_data_grade = get_response.data;
        // console.log(this.table_data_grade);
          this.gettabledata();

        });
    },
    activeDeleteSchoolgradeSidebar: function (grade_id) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
    if (result.isConfirmed) {
      const schoolId = JSON.parse(localStorage.getItem("schoolid"));
      const token = localStorage.getItem("_t");

      const payload = {
        grade_id: grade_id,
        school_id: schoolId,
      };
      axios.delete(
        process.env.VUE_APP_API_URL + "/school_grade/delete",
        {
          data: {
            grade_id: grade_id,
            school_id: schoolId,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        }
      )
      .then((response) => {
                this.toastMessage = "Grade Successfully Deleted";
                this.toastNotification("success");
                this.gettabledata();
              })
              .catch((error) => {
                this.toastMessage = "Try Again Grade Not Deleted";
                this.toastNotification("danger");
              });
          }
        });
      },


    clickeditschoolgradedata : function (GradeData) {
      axios
        .post(
          process.env.VUE_APP_API_URL + "/grade/edit",
          GradeData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
          }
        )
        .then((response) => {
          this.toastMessage = "Grade Successfully Edit";
          this.toastNotification("success");
          this.gettabledata();
        })
        .catch((error) => {
          this.toastMessage = "Try Again Grade Not Edit";
          this.toastNotification("danger");
        });
    },

    toastNotification(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.toastMessage,
          variant,
        },
      });
    },
    sendgradedata: function (grade_data) {

      axios
        .post(process.env.VUE_APP_API_URL + "/school_grade/create", grade_data
          , {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
          }
        )
        .then((response) => {
          if (response.data.message === "Grade created successfully") {
              this.subjectAdded("success");
              this.gettabledata();
            } else {
              this.subjectAddedRejected("danger");
            }
        });
    },
    subjectAdded(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "Grade Added",
          variant,
        },
      });
    },
    subjectAddedRejected(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "Grade not added",
          variant,
        },
      });
    },
    activeEditSchoolGradeSidebar(grade) {
      // console.log(grade),
      this.isAddEditSchoolGradeSidebarActive = true;
      this.Editschoolgradeid = grade._id;
      this.Editschoolgradename = grade.className;
      this.Editschoolgradeimg = grade.classImg;
    },

    gettabledata: function () {
      const schoolId = JSON.parse(localStorage.getItem("schoolid"));
      axios
        .get(process.env.VUE_APP_API_URL + `/school_grade/get`, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
          params: {
            schoolId: schoolId, 
          },
        })
        .then((get_response) => {
          // console.log(get_response.data);
          this.table_data = get_response.data;
          this.keyForLottie += 1;
        })
        .catch((err) => {
          console.error("Failed to fetch grades:", err);
        });
    },

    getSchools() {
          if (this.searchQuery.trim().length > 0) {
              return this.table_data.filter((item) => {
              return item.className && this.searchQuery
                  .toLowerCase()
                  .split(" ")
                  .every((v) => item.className.toLowerCase().includes(v));
              });
          } else {
              return this.table_data;
          }
   },

  
  },
};
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>  